var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('table-filters',{attrs:{"resource":_vm.resource,"settings":_vm.tableSettings,"dictionaries":_vm.dictionaries,"params":_vm.scope,"show-columns":_vm.showColumns,"show-pagination":_vm.showPagination},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var params = ref.params;
var readonly = ref.readonly;
var setParam = ref.setParam;
var clearParam = ref.clearParam;
return [_c(_vm.filters,{tag:"component",attrs:{"filters":_vm.includedFilters,"limit":_vm.limit,"readonly":readonly,"params":params,"set-param":setParam,"clear-param":clearParam}})]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }